import React from 'react';
import { connect } from 'react-redux';
import DriverPositionMap from 'modules/driver-position/Map';

import { withProps, withStateHandlers, lifecycle, compose } from 'recompose';
import { getGPSNow } from 'redux/modules/driver-position/http';
import { Button, Flexer } from '@ontruck/orc';

import { Loading } from 'components/Loading';
import { StyledRefreshWrapper } from './styled';

const t = {
  refresh: 'Refresh positions',
};

const enhance = compose(
  connect((state) => ({
    country: !!state.me && state.me.country,
  })),
  withStateHandlers(
    () => ({
      positions: [],
      loading: false,
    }),
    {
      setPositions: () => (positions) => ({
        positions,
      }),
      toggleLoading:
        ({ loading }) =>
        () => ({
          loading: !loading,
        }),
    }
  ),
  withProps(({ toggleLoading, setPositions }) => ({
    async refreshPositions() {
      try {
        toggleLoading();
        const positions = await getGPSNow();
        setPositions(positions);
      } catch (err) {
      } finally {
        toggleLoading();
      }
    },
  })),
  lifecycle({
    async componentDidMount() {
      const { refreshPositions } = this.props;
      await refreshPositions();
    },
  })
);

const defaultMapOptions = {
  fullscreenControl: false,
};

const DriverPositionSection = ({ country, positions, loading, refreshPositions }) =>
  !!country && (
    <div style={{ height: `100%` }}>
      <DriverPositionMap defaultOptions={defaultMapOptions} positions={positions} country={country}>
        <StyledRefreshWrapper>
          {!!loading && (
            <Flexer.Child mRight="S">
              <Loading />
            </Flexer.Child>
          )}
          <Flexer.Child>
            <Button text={t.refresh} disabled={loading} onClick={refreshPositions} />
          </Flexer.Child>
        </StyledRefreshWrapper>
      </DriverPositionMap>
    </div>
  );

export default enhance(DriverPositionSection);
